//Aqui se guardaran las funciones usadas en el componente padre.


const manejoAlertas = (setAlerta, setMensaje, mensaje, cajonPreguntas, tiempo) => {
    if(cajonPreguntas !== 3 && cajonPreguntas !== 5 && cajonPreguntas !== 11 && cajonPreguntas !== 15 && cajonPreguntas !== 18 &&cajonPreguntas !== 21 &&  cajonPreguntas !== 23 && cajonPreguntas !== 25 && cajonPreguntas !== 27 && cajonPreguntas !== 29 && cajonPreguntas !== 30 && cajonPreguntas !== 31 && cajonPreguntas !== 34 && cajonPreguntas !== 36 && cajonPreguntas !== 37 && cajonPreguntas !== 39 && cajonPreguntas !== 41 && cajonPreguntas !== 45 && cajonPreguntas !== 46 && cajonPreguntas !== 48 && cajonPreguntas !== 49){
        setAlerta(true);
        setMensaje(mensaje);
        setTimeout(() => setAlerta(false), tiempo);
    }else if(cajonPreguntas === 0) {
        setAlerta(true);
        setMensaje(mensaje);
        setTimeout(() => setAlerta(false), tiempo);
    }
}

const manejoAlertasPerderTurno = (setAlerta, setMensaje, mensaje, cajonPreguntas, tiempo) => {

    if(cajonPreguntas !== 3 && cajonPreguntas !== 5 && cajonPreguntas !== 6 &&  cajonPreguntas !== 11 && cajonPreguntas !== 12 && cajonPreguntas !== 15 && cajonPreguntas !== 16 &&  cajonPreguntas !== 18 && cajonPreguntas !== 20 &&  cajonPreguntas !== 21 &&  cajonPreguntas !== 23 && cajonPreguntas !== 25 &&cajonPreguntas !== 26 && cajonPreguntas !== 27 && cajonPreguntas !== 29 && cajonPreguntas !== 30 && cajonPreguntas !== 31 && cajonPreguntas !== 34 &&cajonPreguntas !== 35 && cajonPreguntas !== 36 && cajonPreguntas !== 37 && cajonPreguntas !== 39 && cajonPreguntas !== 41 && cajonPreguntas !== 44 &&  cajonPreguntas !== 45 && cajonPreguntas !== 46 && cajonPreguntas !== 48 && cajonPreguntas !== 49){
        setAlerta(true);
        setMensaje(mensaje);
        setTimeout(() => setAlerta(false), tiempo);
    }else if(cajonPreguntas === 0) {
        setAlerta(true);
        setMensaje(mensaje);
        setTimeout(() => setAlerta(false), tiempo);
    }
}


//Creamos una funcion que guardara en estados asignados a cada ficho en que casilla se encuentran actualmente
const establecerPosicionFichos = ( turno, casillaActual, fichoAzul, fichoRojo, fichoVerde, fichoRosa ) => {

    if( turno === 1){
        fichoAzul(casillaActual);
    }else if(turno === 2){
        fichoRojo(casillaActual);
    }else if(turno === 3){
        fichoVerde(casillaActual);
    }else if(turno === 0 || turno === 4){
        fichoRosa(casillaActual);
    }
}

const asignacionPuntos = ( puntuaciones, setPuntuaciones, turnoActual, puntos ) => {


    if( turnoActual === 2 ){
        puntuaciones[0].puntuacion  = puntuaciones[0].puntuacion + puntos;
    }else if( turnoActual === 3 ){
        puntuaciones[1].puntuacion  = puntuaciones[1].puntuacion + puntos;
    }else if( turnoActual === 4 ){
        puntuaciones[2].puntuacion  = puntuaciones[2].puntuacion + puntos;
    }else if( turnoActual === 1 ){
        puntuaciones[3].puntuacion  = puntuaciones[3].puntuacion + puntos;
    }

    setPuntuaciones(puntuaciones);
}

const asignacionPreguntasAcumulacion = ( puntuaciones, setPuntuaciones, turnoActual) => {


    if( turnoActual === 2 ){
        puntuaciones[0].preguntas = puntuaciones[0].preguntas + 1;
    }else if( turnoActual === 3 ){
        puntuaciones[1].preguntas = puntuaciones[1].preguntas + 1;
    }else if( turnoActual === 4 ){
        puntuaciones[2].preguntas = puntuaciones[2].preguntas + 1;
    }else if( turnoActual === 1 ){
        puntuaciones[3].preguntas = puntuaciones[3].preguntas + 1;
    }

    setPuntuaciones(puntuaciones);
}

//Creamos una funcion que defina si la casilla actual es una pregunta de escalera o de doble tirada.
const corroborarCasillaPregunta = ( casillaActual ) => {
    let result = "casillaEscalera";
    let arrayCasillasPregunta = ["casilla3", "casilla21", "casilla29", "casilla34", "casilla36", "casilla41", "casilla45", "casilla48"];
    let arrayCasillasTobogan = ["casilla18", "casilla25", "casilla31", "casilla39", "casilla46", "casilla49"];

    for( let i = 0; i < arrayCasillasPregunta.length; i++ ){
        if(arrayCasillasPregunta[i] === casillaActual){
            console.log(arrayCasillasPregunta[i]);
            result = "casillaExtra";
        }
    }

    for( let i = 0; i < arrayCasillasTobogan.length; i++ ){
        if(arrayCasillasTobogan[i] === casillaActual){
            console.log(arrayCasillasPregunta[i]);
            result = "casillaTobogan";
        }
    }
    return result;
};

//Creamos una funcion que establezca el turno actual del jugador igual si se acierta la pregunta.
const turnoExtra = ( turnoActualx, setTurnoActual ,setEstadoAlerta, setMensajeAlerta, puntuacion, setPuntuacion ) => {
    if(turnoActualx === 1){
        setTurnoActual(4);
    }else{
        setTurnoActual(turnoActualx - 1);
    }

    manejoAlertas(setEstadoAlerta, setMensajeAlerta, "Turno Extra", 3250);

    asignacionPuntos( puntuacion, setPuntuacion, turnoActualx, 1 );
};


//Establecemos una funcion que determina cuanto dura la pantalla de inicio
const pantallaInicioFuncionamiento = ( setPantallaInicialEstado ) => {
    setTimeout(() => {
        setPantallaInicialEstado(false);
    }, 4000);
}

//Creamos una funcion que segun la casilla de pregunta elija si toma la lista de preguntas del tobogan del turno extra o de la escalera.
const elegirBloqueDePreguntas = (tipoCasillaPregunta, preguntasTurnoExtra, preguntasEscalera, preguntasTobogan) => {
    let result;
    if(tipoCasillaPregunta === "preguntasTurnoEXtra"){
        result = preguntasTurnoExtra;
    }else if(tipoCasillaPregunta === "preguntasEscalera"){
        result = preguntasEscalera;
    }else if(tipoCasillaPregunta === "preguntasTobogan"){
        result = preguntasTobogan
    }else if(tipoCasillaPregunta ==="pregunta funcion"){

    }


    return result
}


//Creamos una funcion que evaluara si el ficho cae en casilla de pista y activa el estado de esa casilla.
const validarCasillasPista = (casilla, setCasillaPista) => {
    switch(casilla) {
        case "casilla6":
            setCasillaPista(true);
            //console.log("casilla detectada");
            break;
        case "casilla12":
            setCasillaPista(true);
            //console.log("casilla detectada");
            break;
        case "casilla16":
            setCasillaPista(true);
            //console.log("casilla detectada");
            break;
        case "casilla20":
            setCasillaPista(true);
            //console.log("casilla detectada");
            break;
        case "casilla26":
            setCasillaPista(true);
            //console.log("casilla detectada");
            break;
        case "casilla35":
            setCasillaPista(true);
            //console.log("casilla detectada");
            break;
        case "casilla44":
            setCasillaPista(true);
            //console.log("casilla detectada");
            break;
        default:
            // code block

    }
}

//Creamos una funcion que maneje los estados del turno actual para el cambio del color del dado.
const cambioTurnoControlEstados = (setSaltarTurnoDado) => {
    setSaltarTurnoDado(true);
    setTimeout(() => {
        setSaltarTurnoDado(false);
    }, 1000);
};



export { manejoAlertas, establecerPosicionFichos, manejoAlertasPerderTurno, asignacionPuntos, corroborarCasillaPregunta, turnoExtra, pantallaInicioFuncionamiento, elegirBloqueDePreguntas, asignacionPreguntasAcumulacion, validarCasillasPista, cambioTurnoControlEstados };